<script>
import { required } from 'vuelidate/lib/validators'

import axios from 'axios'

export default {
	props: {
		url: {
			type: String,
			default: '/pan/xdr/manual_assets?_=_',
		}
	},
	data() {
		return {
			appConfig: {},
			asset: {},
			category: 'List',
			items: [
				{
					text: 'Home',
					href: '/',
				},
				{
					text: 'Assets View',
					active: true,
				},
			],
			appConfig: process.env.NODE_ENV === 'production' ? require('@src/app.config') : require('@src/app.config.dev'),
			incidents: [],
			tableData: [],
			totalRows: 1,
			currentPage: 1,
			perPage: 10,
			pageOptions: [10, 25, 50, 100],
			filter: '',
			filterOn: [],
			sortBy: 'reputation',
			sortDesc: true,
			fields: [
				{ key: 'type', sortable: true },
				{ key: 'name', label: 'Name', sortable: true },
				{ key: 'local_ip', label: 'Local IP', sortable: true },
				{ key: 'global_ip', label: 'Global IP', sortable: true },
				{ key: 'company', label: 'Company', sortable: true },
				{ key: 'division', label: 'Divison', sortable: true },
				{ key: 'location', label: 'Location', sortable: true },
				{ key: 'desc', label: 'Description', sortable: true },
				{ key: 'action', sortable: false },


				// { key: 'reputation', sortable: true },
				// { key: 'incidents', sortable: true },
				// { key: 'alerts', sortable: true },
				// { key: 'last_update', sortable: true },
			],
			isBusy: true
		}
	},
	validations: {
		event: {
			title: { required },
			category: { required },
		},
	},
	computed: {
		rows() {
			return this.tableData.length
		},
	},
	mounted () {
		this.loadData()
	},
	methods: {
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		showDetails (data) {
			if (data === undefined || data.name === undefined) return
			this.asset = data
			this.$refs['modal-details'].show()
		},
		handleOkDetails (evt) {
			evt.preventDefault()
			let that = this
		},
		doSearch() {
			let filter = this.filter
			if (filter.length !== undefined) {
				this.loadData(filter)
			}
		},
		keyFormat (key) {
			let keyParts = key.split('_').map(function(fKey){
				if (fKey.length > 3) {
					fKey = fKey[0].toUpperCase() + fKey.slice(1)
				} else {
					fKey = fKey.toUpperCase()
				}
				return fKey		
			})
			return keyParts.join(' ')
		},
		loadData (src='') {
			let that = this
			that.isBusy = true


			let baseURL = that.appConfig.xdrAPI.baseURL || 'http://localhost:5000'
			const countURL =  (src.length < 1) ? `${baseURL}${that.url}&count=yes` : `${baseURL}${that.url}&rawsearch=${src}&count=yes`
			axios.get(countURL)
			.then((response) => {
				that.totalRows = parseInt(response.data)
        console.log('totalRows', that.totalRows)
			})
			.catch(function (error) {
				return
			}) 


			const dataURL = (src.length < 1 ) ? 
				`${baseURL}${that.url}&page=${that.currentPage}&page_size=${that.perPage}&limit=${that.perPage}` :
				`${baseURL}${that.url}&page=${that.currentPage}&page_size=${that.perPage}&limit=${that.perPage}&rawsearch=${src}`
			axios.get(dataURL).then((response) => {
				if (response.status === 200) {
				  console.log('data', response.data)
					that.tableData = response.data.map(function(entry){
						return {
							type: entry.manual_type.toUpperCase()[0] + entry.manual_type.slice(1),
							name: entry.name,
							dns_name: entry.dns_name,
							local_ip: entry.local_ip,
							global_ip: entry.global_ip,
							desc: entry.desc,
							role: entry.role,
							os: entry.os,
							company: entry.company,
							division: entry.division,
							location: entry.location,
							user_full_name: entry.user_fullname,
							app_responsable: entry.app_responsable,
							datacenter: entry.datacenter,
							serial: entry.serial,
						}
					})
				}
				that.isBusy = false
			})
			.catch(function (error) {

			}) 
		},
	},
	watch: {
		currentPage: {
			handler: function(value) {
				this.loadData(this.filter)
			}
		},
		perPage: {
			handler: function(value) {
				this.loadData(this.filter)
			}
		},
	}
}
</script>

<template>
	<div>
		<div class="row mb-md-2">
			<div class="col-sm-6 col-md-6">
				<span>
					Found: 
					<b>
						{{ totalRows }}
					</b>
					at
					<b>
						{{ new Date().toLocaleString() }}
					</b>
				</span>
			</div>

			<div class="col-sm-6 col-md-6">
				<div
					id="tickets-table_filter"
					class="dataTables_filter text-md-right"
				>
					<label class="d-inline-flex align-items-center">
						<b-form-input
							v-model="filter"
							type="search"
							placeholder="Text to search..."
							class="form-control form-control-sm ml-2"
						></b-form-input>
						<b-button size="sm" variant="light" @click="doSearch">
							Search
						</b-button>
					</label>
				</div>
			</div>
		</div>
		<div class="table-responsive mb-0">
			<b-table
				:items="tableData"
				:fields="fields"
				:busy="isBusy"
				responsive="sm"
				:per-page="0"
				:current-page="currentPage"
				:sort-by.sync="sortBy"
				:sort-desc.sync="sortDesc"
				:totalRows="totalRows"
				:pagination-options="{
					enabled: true
				}"
			>
				<template v-slot:table-busy>
					<div class="text-center">
					<br><br>
					<b-spinner class="align-middle"></b-spinner>
					<strong>&nbsp;&nbsp;Loading...</strong>
					</div>
				</template>
				<template v-slot:cell(type)="data">
					<template v-if="data.item.type === 'Computer'">
						<feather type="monitor" class="icon-xs icon-dual"></feather>
					</template>
					<template v-else-if="data.item.type === 'Server'">
						<feather type="server" class="icon-xs icon-dual"></feather>
					</template>
				</template>
				<template v-slot:cell(action)="data">
					<b-dropdown right variant="white" class="align-self-center" toggle-class="p-0">
						<template v-slot:button-content>
							<feather type="chevron-down" class="align-middle" style="height:12px !important;width:20px !important;"></feather>
						</template>
						<b-dropdown-item @click="showDetails(data.item)" class="notify-item">
							<feather
								type="search"
								class="icon-dual icon-xs mr-2 align-middle"
							></feather>
							<span>Details</span>
						</b-dropdown-item>
					</b-dropdown>
				</template>
			</b-table>
		</div>
		<div class="row">
			<div class="col-sm-12 col-md-6">
				<div id="tickets-table_length" class="dataTables_length">
					<label class="d-inline-flex align-items-center">
						Show&nbsp;
						<b-form-select
							v-model="perPage"
							size="sm"
							:options="pageOptions"
						></b-form-select
						>&nbsp;entries
					</label>
				</div>
			</div>
			<div class="col">
				<div
					class="dataTables_paginate paging_simple_numbers float-right"
				>
					<ul class="pagination pagination-rounded mb-0">
						<b-pagination
							v-model="currentPage"
							:total-rows="totalRows"
							:per-page="perPage"
						></b-pagination>
					</ul>
				</div>
			</div>
		</div>
		<b-modal
			ref="modal-details"
			id="asset.name"
			size="xl"
			title="Asset Details"
			:centered=true
			:no-fade=true
			ok-only>
			<ul>
				<template v-for="data, index in Object.keys(asset)" vbind:key="index">
					<li v-if="asset[data] !== undefined">
						<span style="color:#224455; font-weight:500;">
							{{ keyFormat(data) + ': ' }}
						</span>
						<span>
							{{ asset[data] }}
						</span>
					</li>
				</template>
			</ul>
		</b-modal>
	</div>
</template>
